// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/SettingsModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Int32Value, StringValue } from "../../../google/protobuf/wrappers";
import { DriveSettings } from "./HostModels";
import { ThinkLevels, thinkLevelsFromJSON, thinkLevelsToJSON } from "./InferenceModels";
import { Peer } from "./PeerModels";

export const protobufPackage = "daisi.protos.v1";

export enum LLamaRuntimes {
  Auto = 0,
  Cuda = 1,
  Vulkan = 2,
  Avx = 3,
  Avx2 = 4,
  Avx512 = 5,
  UNRECOGNIZED = -1,
}

export function lLamaRuntimesFromJSON(object: any): LLamaRuntimes {
  switch (object) {
    case 0:
    case "Auto":
      return LLamaRuntimes.Auto;
    case 1:
    case "Cuda":
      return LLamaRuntimes.Cuda;
    case 2:
    case "Vulkan":
      return LLamaRuntimes.Vulkan;
    case 3:
    case "Avx":
      return LLamaRuntimes.Avx;
    case 4:
    case "Avx2":
      return LLamaRuntimes.Avx2;
    case 5:
    case "Avx512":
      return LLamaRuntimes.Avx512;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LLamaRuntimes.UNRECOGNIZED;
  }
}

export function lLamaRuntimesToJSON(object: LLamaRuntimes): string {
  switch (object) {
    case LLamaRuntimes.Auto:
      return "Auto";
    case LLamaRuntimes.Cuda:
      return "Cuda";
    case LLamaRuntimes.Vulkan:
      return "Vulkan";
    case LLamaRuntimes.Avx:
      return "Avx";
    case LLamaRuntimes.Avx2:
      return "Avx2";
    case LLamaRuntimes.Avx512:
      return "Avx512";
    case LLamaRuntimes.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StorageLocations {
  None = 0,
  Local = 1,
  Cloud = 2,
  UNRECOGNIZED = -1,
}

export function storageLocationsFromJSON(object: any): StorageLocations {
  switch (object) {
    case 0:
    case "None":
      return StorageLocations.None;
    case 1:
    case "Local":
      return StorageLocations.Local;
    case 2:
    case "Cloud":
      return StorageLocations.Cloud;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StorageLocations.UNRECOGNIZED;
  }
}

export function storageLocationsToJSON(object: StorageLocations): string {
  switch (object) {
    case StorageLocations.None:
      return "None";
    case StorageLocations.Local:
      return "Local";
    case StorageLocations.Cloud:
      return "Cloud";
    case StorageLocations.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface GetAllSettingsRequest {
  SessionId?: string | undefined;
}

export interface GetAllSettingsResponse {
  Settings?: Settings | undefined;
}

export interface Settings {
  Peer?: PeerSettings | undefined;
  Host?: HostSettings | undefined;
  Model?: ModelSettings | undefined;
  Storage?: StorageSettings | undefined;
  Drive?: DriveSettings | undefined;
}

export interface SetAllSettingsRequest {
  SessionId?: string | undefined;
  Settings?: Settings | undefined;
}

export interface SetAllSettingsResponse {
  Success: boolean;
}

export interface PeerSettings {
  Peers: Peer[];
  DiscoveryPort: number;
  MaxPeers: number;
}

export interface ModelSettings {
  ModelFolderPath: string;
  Models: AIModel[];
  AutomaticDownloads: boolean;
  LLama?: LLamaSettings | undefined;
}

export interface HostSettings {
  Id: string;
  Name: string;
  MaxConcurrentSessions: number;
  SecretKey: string;
  OrcIpAddressOrDomain?: string | undefined;
  OrcPort?: number | undefined;
  AutoUpdate: boolean;
  LogLevel: string;
  OrcUseSSL: boolean;
}

export interface LLamaSettings {
  Runtime: LLamaRuntimes;
  ShowLogs: boolean;
  AutoFallback: boolean;
  SkipCheck: boolean;
  LlamaPath: string;
  LlavaPath: string;
  ContextSize: number;
  GpuLayerCount: number;
  BatchSize: number;
}

export interface AIModel {
  Name: string;
  FileName: string;
  Url: string;
  IsMultiModal: boolean;
  IsDefault: boolean;
  Enabled: boolean;
  LoadAtStartup: boolean;
  ThinkLevels: ThinkLevels[];
  HasReasoning: boolean;
  LLama?: LLamaSettings | undefined;
  Id: string;
}

export interface StorageSettings {
  Location: StorageLocations;
  LocalPath: string;
}

function createBaseGetAllSettingsRequest(): GetAllSettingsRequest {
  return { SessionId: undefined };
}

export const GetAllSettingsRequest: MessageFns<GetAllSettingsRequest> = {
  encode(message: GetAllSettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SessionId !== undefined) {
      StringValue.encode({ value: message.SessionId! }, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllSettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SessionId = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllSettingsRequest {
    return { SessionId: isSet(object.SessionId) ? String(object.SessionId) : undefined };
  },

  toJSON(message: GetAllSettingsRequest): unknown {
    const obj: any = {};
    if (message.SessionId !== undefined) {
      obj.SessionId = message.SessionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllSettingsRequest>, I>>(base?: I): GetAllSettingsRequest {
    return GetAllSettingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllSettingsRequest>, I>>(object: I): GetAllSettingsRequest {
    const message = createBaseGetAllSettingsRequest();
    message.SessionId = object.SessionId ?? undefined;
    return message;
  },
};

function createBaseGetAllSettingsResponse(): GetAllSettingsResponse {
  return { Settings: undefined };
}

export const GetAllSettingsResponse: MessageFns<GetAllSettingsResponse> = {
  encode(message: GetAllSettingsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Settings !== undefined) {
      Settings.encode(message.Settings, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllSettingsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllSettingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Settings = Settings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllSettingsResponse {
    return { Settings: isSet(object.Settings) ? Settings.fromJSON(object.Settings) : undefined };
  },

  toJSON(message: GetAllSettingsResponse): unknown {
    const obj: any = {};
    if (message.Settings !== undefined) {
      obj.Settings = Settings.toJSON(message.Settings);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllSettingsResponse>, I>>(base?: I): GetAllSettingsResponse {
    return GetAllSettingsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllSettingsResponse>, I>>(object: I): GetAllSettingsResponse {
    const message = createBaseGetAllSettingsResponse();
    message.Settings = (object.Settings !== undefined && object.Settings !== null)
      ? Settings.fromPartial(object.Settings)
      : undefined;
    return message;
  },
};

function createBaseSettings(): Settings {
  return { Peer: undefined, Host: undefined, Model: undefined, Storage: undefined, Drive: undefined };
}

export const Settings: MessageFns<Settings> = {
  encode(message: Settings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Peer !== undefined) {
      PeerSettings.encode(message.Peer, writer.uint32(10).fork()).join();
    }
    if (message.Host !== undefined) {
      HostSettings.encode(message.Host, writer.uint32(18).fork()).join();
    }
    if (message.Model !== undefined) {
      ModelSettings.encode(message.Model, writer.uint32(26).fork()).join();
    }
    if (message.Storage !== undefined) {
      StorageSettings.encode(message.Storage, writer.uint32(34).fork()).join();
    }
    if (message.Drive !== undefined) {
      DriveSettings.encode(message.Drive, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Settings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Peer = PeerSettings.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Host = HostSettings.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Model = ModelSettings.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.Storage = StorageSettings.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.Drive = DriveSettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Settings {
    return {
      Peer: isSet(object.Peer) ? PeerSettings.fromJSON(object.Peer) : undefined,
      Host: isSet(object.Host) ? HostSettings.fromJSON(object.Host) : undefined,
      Model: isSet(object.Model) ? ModelSettings.fromJSON(object.Model) : undefined,
      Storage: isSet(object.Storage) ? StorageSettings.fromJSON(object.Storage) : undefined,
      Drive: isSet(object.Drive) ? DriveSettings.fromJSON(object.Drive) : undefined,
    };
  },

  toJSON(message: Settings): unknown {
    const obj: any = {};
    if (message.Peer !== undefined) {
      obj.Peer = PeerSettings.toJSON(message.Peer);
    }
    if (message.Host !== undefined) {
      obj.Host = HostSettings.toJSON(message.Host);
    }
    if (message.Model !== undefined) {
      obj.Model = ModelSettings.toJSON(message.Model);
    }
    if (message.Storage !== undefined) {
      obj.Storage = StorageSettings.toJSON(message.Storage);
    }
    if (message.Drive !== undefined) {
      obj.Drive = DriveSettings.toJSON(message.Drive);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Settings>, I>>(base?: I): Settings {
    return Settings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Settings>, I>>(object: I): Settings {
    const message = createBaseSettings();
    message.Peer = (object.Peer !== undefined && object.Peer !== null)
      ? PeerSettings.fromPartial(object.Peer)
      : undefined;
    message.Host = (object.Host !== undefined && object.Host !== null)
      ? HostSettings.fromPartial(object.Host)
      : undefined;
    message.Model = (object.Model !== undefined && object.Model !== null)
      ? ModelSettings.fromPartial(object.Model)
      : undefined;
    message.Storage = (object.Storage !== undefined && object.Storage !== null)
      ? StorageSettings.fromPartial(object.Storage)
      : undefined;
    message.Drive = (object.Drive !== undefined && object.Drive !== null)
      ? DriveSettings.fromPartial(object.Drive)
      : undefined;
    return message;
  },
};

function createBaseSetAllSettingsRequest(): SetAllSettingsRequest {
  return { SessionId: undefined, Settings: undefined };
}

export const SetAllSettingsRequest: MessageFns<SetAllSettingsRequest> = {
  encode(message: SetAllSettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SessionId !== undefined) {
      StringValue.encode({ value: message.SessionId! }, writer.uint32(10).fork()).join();
    }
    if (message.Settings !== undefined) {
      Settings.encode(message.Settings, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetAllSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetAllSettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SessionId = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Settings = Settings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetAllSettingsRequest {
    return {
      SessionId: isSet(object.SessionId) ? String(object.SessionId) : undefined,
      Settings: isSet(object.Settings) ? Settings.fromJSON(object.Settings) : undefined,
    };
  },

  toJSON(message: SetAllSettingsRequest): unknown {
    const obj: any = {};
    if (message.SessionId !== undefined) {
      obj.SessionId = message.SessionId;
    }
    if (message.Settings !== undefined) {
      obj.Settings = Settings.toJSON(message.Settings);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetAllSettingsRequest>, I>>(base?: I): SetAllSettingsRequest {
    return SetAllSettingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetAllSettingsRequest>, I>>(object: I): SetAllSettingsRequest {
    const message = createBaseSetAllSettingsRequest();
    message.SessionId = object.SessionId ?? undefined;
    message.Settings = (object.Settings !== undefined && object.Settings !== null)
      ? Settings.fromPartial(object.Settings)
      : undefined;
    return message;
  },
};

function createBaseSetAllSettingsResponse(): SetAllSettingsResponse {
  return { Success: false };
}

export const SetAllSettingsResponse: MessageFns<SetAllSettingsResponse> = {
  encode(message: SetAllSettingsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetAllSettingsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetAllSettingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetAllSettingsResponse {
    return { Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false };
  },

  toJSON(message: SetAllSettingsResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetAllSettingsResponse>, I>>(base?: I): SetAllSettingsResponse {
    return SetAllSettingsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetAllSettingsResponse>, I>>(object: I): SetAllSettingsResponse {
    const message = createBaseSetAllSettingsResponse();
    message.Success = object.Success ?? false;
    return message;
  },
};

function createBasePeerSettings(): PeerSettings {
  return { Peers: [], DiscoveryPort: 0, MaxPeers: 0 };
}

export const PeerSettings: MessageFns<PeerSettings> = {
  encode(message: PeerSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Peers) {
      Peer.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.DiscoveryPort !== 0) {
      writer.uint32(16).int32(message.DiscoveryPort);
    }
    if (message.MaxPeers !== 0) {
      writer.uint32(24).int32(message.MaxPeers);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PeerSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePeerSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Peers.push(Peer.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.DiscoveryPort = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.MaxPeers = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PeerSettings {
    return {
      Peers: globalThis.Array.isArray(object?.Peers) ? object.Peers.map((e: any) => Peer.fromJSON(e)) : [],
      DiscoveryPort: isSet(object.DiscoveryPort) ? globalThis.Number(object.DiscoveryPort) : 0,
      MaxPeers: isSet(object.MaxPeers) ? globalThis.Number(object.MaxPeers) : 0,
    };
  },

  toJSON(message: PeerSettings): unknown {
    const obj: any = {};
    if (message.Peers?.length) {
      obj.Peers = message.Peers.map((e) => Peer.toJSON(e));
    }
    if (message.DiscoveryPort !== 0) {
      obj.DiscoveryPort = Math.round(message.DiscoveryPort);
    }
    if (message.MaxPeers !== 0) {
      obj.MaxPeers = Math.round(message.MaxPeers);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PeerSettings>, I>>(base?: I): PeerSettings {
    return PeerSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PeerSettings>, I>>(object: I): PeerSettings {
    const message = createBasePeerSettings();
    message.Peers = object.Peers?.map((e) => Peer.fromPartial(e)) || [];
    message.DiscoveryPort = object.DiscoveryPort ?? 0;
    message.MaxPeers = object.MaxPeers ?? 0;
    return message;
  },
};

function createBaseModelSettings(): ModelSettings {
  return { ModelFolderPath: "", Models: [], AutomaticDownloads: false, LLama: undefined };
}

export const ModelSettings: MessageFns<ModelSettings> = {
  encode(message: ModelSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ModelFolderPath !== "") {
      writer.uint32(10).string(message.ModelFolderPath);
    }
    for (const v of message.Models) {
      AIModel.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.AutomaticDownloads !== false) {
      writer.uint32(24).bool(message.AutomaticDownloads);
    }
    if (message.LLama !== undefined) {
      LLamaSettings.encode(message.LLama, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModelSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModelSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ModelFolderPath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Models.push(AIModel.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.AutomaticDownloads = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.LLama = LLamaSettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModelSettings {
    return {
      ModelFolderPath: isSet(object.ModelFolderPath) ? globalThis.String(object.ModelFolderPath) : "",
      Models: globalThis.Array.isArray(object?.Models) ? object.Models.map((e: any) => AIModel.fromJSON(e)) : [],
      AutomaticDownloads: isSet(object.AutomaticDownloads) ? globalThis.Boolean(object.AutomaticDownloads) : false,
      LLama: isSet(object.LLama) ? LLamaSettings.fromJSON(object.LLama) : undefined,
    };
  },

  toJSON(message: ModelSettings): unknown {
    const obj: any = {};
    if (message.ModelFolderPath !== "") {
      obj.ModelFolderPath = message.ModelFolderPath;
    }
    if (message.Models?.length) {
      obj.Models = message.Models.map((e) => AIModel.toJSON(e));
    }
    if (message.AutomaticDownloads !== false) {
      obj.AutomaticDownloads = message.AutomaticDownloads;
    }
    if (message.LLama !== undefined) {
      obj.LLama = LLamaSettings.toJSON(message.LLama);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModelSettings>, I>>(base?: I): ModelSettings {
    return ModelSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModelSettings>, I>>(object: I): ModelSettings {
    const message = createBaseModelSettings();
    message.ModelFolderPath = object.ModelFolderPath ?? "";
    message.Models = object.Models?.map((e) => AIModel.fromPartial(e)) || [];
    message.AutomaticDownloads = object.AutomaticDownloads ?? false;
    message.LLama = (object.LLama !== undefined && object.LLama !== null)
      ? LLamaSettings.fromPartial(object.LLama)
      : undefined;
    return message;
  },
};

function createBaseHostSettings(): HostSettings {
  return {
    Id: "",
    Name: "",
    MaxConcurrentSessions: 0,
    SecretKey: "",
    OrcIpAddressOrDomain: undefined,
    OrcPort: undefined,
    AutoUpdate: false,
    LogLevel: "",
    OrcUseSSL: false,
  };
}

export const HostSettings: MessageFns<HostSettings> = {
  encode(message: HostSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.Name !== "") {
      writer.uint32(18).string(message.Name);
    }
    if (message.MaxConcurrentSessions !== 0) {
      writer.uint32(24).int32(message.MaxConcurrentSessions);
    }
    if (message.SecretKey !== "") {
      writer.uint32(34).string(message.SecretKey);
    }
    if (message.OrcIpAddressOrDomain !== undefined) {
      StringValue.encode({ value: message.OrcIpAddressOrDomain! }, writer.uint32(42).fork()).join();
    }
    if (message.OrcPort !== undefined) {
      Int32Value.encode({ value: message.OrcPort! }, writer.uint32(50).fork()).join();
    }
    if (message.AutoUpdate !== false) {
      writer.uint32(56).bool(message.AutoUpdate);
    }
    if (message.LogLevel !== "") {
      writer.uint32(66).string(message.LogLevel);
    }
    if (message.OrcUseSSL !== false) {
      writer.uint32(72).bool(message.OrcUseSSL);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HostSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHostSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.MaxConcurrentSessions = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.SecretKey = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.OrcIpAddressOrDomain = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.OrcPort = Int32Value.decode(reader, reader.uint32()).value;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.AutoUpdate = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.LogLevel = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.OrcUseSSL = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HostSettings {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      MaxConcurrentSessions: isSet(object.MaxConcurrentSessions) ? globalThis.Number(object.MaxConcurrentSessions) : 0,
      SecretKey: isSet(object.SecretKey) ? globalThis.String(object.SecretKey) : "",
      OrcIpAddressOrDomain: isSet(object.OrcIpAddressOrDomain) ? String(object.OrcIpAddressOrDomain) : undefined,
      OrcPort: isSet(object.OrcPort) ? Number(object.OrcPort) : undefined,
      AutoUpdate: isSet(object.AutoUpdate) ? globalThis.Boolean(object.AutoUpdate) : false,
      LogLevel: isSet(object.LogLevel) ? globalThis.String(object.LogLevel) : "",
      OrcUseSSL: isSet(object.OrcUseSSL) ? globalThis.Boolean(object.OrcUseSSL) : false,
    };
  },

  toJSON(message: HostSettings): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.MaxConcurrentSessions !== 0) {
      obj.MaxConcurrentSessions = Math.round(message.MaxConcurrentSessions);
    }
    if (message.SecretKey !== "") {
      obj.SecretKey = message.SecretKey;
    }
    if (message.OrcIpAddressOrDomain !== undefined) {
      obj.OrcIpAddressOrDomain = message.OrcIpAddressOrDomain;
    }
    if (message.OrcPort !== undefined) {
      obj.OrcPort = message.OrcPort;
    }
    if (message.AutoUpdate !== false) {
      obj.AutoUpdate = message.AutoUpdate;
    }
    if (message.LogLevel !== "") {
      obj.LogLevel = message.LogLevel;
    }
    if (message.OrcUseSSL !== false) {
      obj.OrcUseSSL = message.OrcUseSSL;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HostSettings>, I>>(base?: I): HostSettings {
    return HostSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HostSettings>, I>>(object: I): HostSettings {
    const message = createBaseHostSettings();
    message.Id = object.Id ?? "";
    message.Name = object.Name ?? "";
    message.MaxConcurrentSessions = object.MaxConcurrentSessions ?? 0;
    message.SecretKey = object.SecretKey ?? "";
    message.OrcIpAddressOrDomain = object.OrcIpAddressOrDomain ?? undefined;
    message.OrcPort = object.OrcPort ?? undefined;
    message.AutoUpdate = object.AutoUpdate ?? false;
    message.LogLevel = object.LogLevel ?? "";
    message.OrcUseSSL = object.OrcUseSSL ?? false;
    return message;
  },
};

function createBaseLLamaSettings(): LLamaSettings {
  return {
    Runtime: 0,
    ShowLogs: false,
    AutoFallback: false,
    SkipCheck: false,
    LlamaPath: "",
    LlavaPath: "",
    ContextSize: 0,
    GpuLayerCount: 0,
    BatchSize: 0,
  };
}

export const LLamaSettings: MessageFns<LLamaSettings> = {
  encode(message: LLamaSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Runtime !== 0) {
      writer.uint32(8).int32(message.Runtime);
    }
    if (message.ShowLogs !== false) {
      writer.uint32(16).bool(message.ShowLogs);
    }
    if (message.AutoFallback !== false) {
      writer.uint32(24).bool(message.AutoFallback);
    }
    if (message.SkipCheck !== false) {
      writer.uint32(32).bool(message.SkipCheck);
    }
    if (message.LlamaPath !== "") {
      writer.uint32(42).string(message.LlamaPath);
    }
    if (message.LlavaPath !== "") {
      writer.uint32(50).string(message.LlavaPath);
    }
    if (message.ContextSize !== 0) {
      writer.uint32(56).uint32(message.ContextSize);
    }
    if (message.GpuLayerCount !== 0) {
      writer.uint32(64).int32(message.GpuLayerCount);
    }
    if (message.BatchSize !== 0) {
      writer.uint32(72).uint32(message.BatchSize);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LLamaSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLLamaSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Runtime = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.ShowLogs = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.AutoFallback = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.SkipCheck = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.LlamaPath = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.LlavaPath = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.ContextSize = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.GpuLayerCount = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.BatchSize = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LLamaSettings {
    return {
      Runtime: isSet(object.Runtime) ? lLamaRuntimesFromJSON(object.Runtime) : 0,
      ShowLogs: isSet(object.ShowLogs) ? globalThis.Boolean(object.ShowLogs) : false,
      AutoFallback: isSet(object.AutoFallback) ? globalThis.Boolean(object.AutoFallback) : false,
      SkipCheck: isSet(object.SkipCheck) ? globalThis.Boolean(object.SkipCheck) : false,
      LlamaPath: isSet(object.LlamaPath) ? globalThis.String(object.LlamaPath) : "",
      LlavaPath: isSet(object.LlavaPath) ? globalThis.String(object.LlavaPath) : "",
      ContextSize: isSet(object.ContextSize) ? globalThis.Number(object.ContextSize) : 0,
      GpuLayerCount: isSet(object.GpuLayerCount) ? globalThis.Number(object.GpuLayerCount) : 0,
      BatchSize: isSet(object.BatchSize) ? globalThis.Number(object.BatchSize) : 0,
    };
  },

  toJSON(message: LLamaSettings): unknown {
    const obj: any = {};
    if (message.Runtime !== 0) {
      obj.Runtime = lLamaRuntimesToJSON(message.Runtime);
    }
    if (message.ShowLogs !== false) {
      obj.ShowLogs = message.ShowLogs;
    }
    if (message.AutoFallback !== false) {
      obj.AutoFallback = message.AutoFallback;
    }
    if (message.SkipCheck !== false) {
      obj.SkipCheck = message.SkipCheck;
    }
    if (message.LlamaPath !== "") {
      obj.LlamaPath = message.LlamaPath;
    }
    if (message.LlavaPath !== "") {
      obj.LlavaPath = message.LlavaPath;
    }
    if (message.ContextSize !== 0) {
      obj.ContextSize = Math.round(message.ContextSize);
    }
    if (message.GpuLayerCount !== 0) {
      obj.GpuLayerCount = Math.round(message.GpuLayerCount);
    }
    if (message.BatchSize !== 0) {
      obj.BatchSize = Math.round(message.BatchSize);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LLamaSettings>, I>>(base?: I): LLamaSettings {
    return LLamaSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LLamaSettings>, I>>(object: I): LLamaSettings {
    const message = createBaseLLamaSettings();
    message.Runtime = object.Runtime ?? 0;
    message.ShowLogs = object.ShowLogs ?? false;
    message.AutoFallback = object.AutoFallback ?? false;
    message.SkipCheck = object.SkipCheck ?? false;
    message.LlamaPath = object.LlamaPath ?? "";
    message.LlavaPath = object.LlavaPath ?? "";
    message.ContextSize = object.ContextSize ?? 0;
    message.GpuLayerCount = object.GpuLayerCount ?? 0;
    message.BatchSize = object.BatchSize ?? 0;
    return message;
  },
};

function createBaseAIModel(): AIModel {
  return {
    Name: "",
    FileName: "",
    Url: "",
    IsMultiModal: false,
    IsDefault: false,
    Enabled: false,
    LoadAtStartup: false,
    ThinkLevels: [],
    HasReasoning: false,
    LLama: undefined,
    Id: "",
  };
}

export const AIModel: MessageFns<AIModel> = {
  encode(message: AIModel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Name !== "") {
      writer.uint32(10).string(message.Name);
    }
    if (message.FileName !== "") {
      writer.uint32(18).string(message.FileName);
    }
    if (message.Url !== "") {
      writer.uint32(26).string(message.Url);
    }
    if (message.IsMultiModal !== false) {
      writer.uint32(32).bool(message.IsMultiModal);
    }
    if (message.IsDefault !== false) {
      writer.uint32(40).bool(message.IsDefault);
    }
    if (message.Enabled !== false) {
      writer.uint32(48).bool(message.Enabled);
    }
    if (message.LoadAtStartup !== false) {
      writer.uint32(56).bool(message.LoadAtStartup);
    }
    writer.uint32(66).fork();
    for (const v of message.ThinkLevels) {
      writer.int32(v);
    }
    writer.join();
    if (message.HasReasoning !== false) {
      writer.uint32(72).bool(message.HasReasoning);
    }
    if (message.LLama !== undefined) {
      LLamaSettings.encode(message.LLama, writer.uint32(82).fork()).join();
    }
    if (message.Id !== "") {
      writer.uint32(90).string(message.Id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AIModel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAIModel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.FileName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Url = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.IsMultiModal = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.IsDefault = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.Enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.LoadAtStartup = reader.bool();
          continue;
        }
        case 8: {
          if (tag === 64) {
            message.ThinkLevels.push(reader.int32() as any);

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.ThinkLevels.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.HasReasoning = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.LLama = LLamaSettings.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AIModel {
    return {
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      FileName: isSet(object.FileName) ? globalThis.String(object.FileName) : "",
      Url: isSet(object.Url) ? globalThis.String(object.Url) : "",
      IsMultiModal: isSet(object.IsMultiModal) ? globalThis.Boolean(object.IsMultiModal) : false,
      IsDefault: isSet(object.IsDefault) ? globalThis.Boolean(object.IsDefault) : false,
      Enabled: isSet(object.Enabled) ? globalThis.Boolean(object.Enabled) : false,
      LoadAtStartup: isSet(object.LoadAtStartup) ? globalThis.Boolean(object.LoadAtStartup) : false,
      ThinkLevels: globalThis.Array.isArray(object?.ThinkLevels)
        ? object.ThinkLevels.map((e: any) => thinkLevelsFromJSON(e))
        : [],
      HasReasoning: isSet(object.HasReasoning) ? globalThis.Boolean(object.HasReasoning) : false,
      LLama: isSet(object.LLama) ? LLamaSettings.fromJSON(object.LLama) : undefined,
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
    };
  },

  toJSON(message: AIModel): unknown {
    const obj: any = {};
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.FileName !== "") {
      obj.FileName = message.FileName;
    }
    if (message.Url !== "") {
      obj.Url = message.Url;
    }
    if (message.IsMultiModal !== false) {
      obj.IsMultiModal = message.IsMultiModal;
    }
    if (message.IsDefault !== false) {
      obj.IsDefault = message.IsDefault;
    }
    if (message.Enabled !== false) {
      obj.Enabled = message.Enabled;
    }
    if (message.LoadAtStartup !== false) {
      obj.LoadAtStartup = message.LoadAtStartup;
    }
    if (message.ThinkLevels?.length) {
      obj.ThinkLevels = message.ThinkLevels.map((e) => thinkLevelsToJSON(e));
    }
    if (message.HasReasoning !== false) {
      obj.HasReasoning = message.HasReasoning;
    }
    if (message.LLama !== undefined) {
      obj.LLama = LLamaSettings.toJSON(message.LLama);
    }
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AIModel>, I>>(base?: I): AIModel {
    return AIModel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AIModel>, I>>(object: I): AIModel {
    const message = createBaseAIModel();
    message.Name = object.Name ?? "";
    message.FileName = object.FileName ?? "";
    message.Url = object.Url ?? "";
    message.IsMultiModal = object.IsMultiModal ?? false;
    message.IsDefault = object.IsDefault ?? false;
    message.Enabled = object.Enabled ?? false;
    message.LoadAtStartup = object.LoadAtStartup ?? false;
    message.ThinkLevels = object.ThinkLevels?.map((e) => e) || [];
    message.HasReasoning = object.HasReasoning ?? false;
    message.LLama = (object.LLama !== undefined && object.LLama !== null)
      ? LLamaSettings.fromPartial(object.LLama)
      : undefined;
    message.Id = object.Id ?? "";
    return message;
  },
};

function createBaseStorageSettings(): StorageSettings {
  return { Location: 0, LocalPath: "" };
}

export const StorageSettings: MessageFns<StorageSettings> = {
  encode(message: StorageSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Location !== 0) {
      writer.uint32(8).int32(message.Location);
    }
    if (message.LocalPath !== "") {
      writer.uint32(18).string(message.LocalPath);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StorageSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStorageSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Location = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.LocalPath = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StorageSettings {
    return {
      Location: isSet(object.Location) ? storageLocationsFromJSON(object.Location) : 0,
      LocalPath: isSet(object.LocalPath) ? globalThis.String(object.LocalPath) : "",
    };
  },

  toJSON(message: StorageSettings): unknown {
    const obj: any = {};
    if (message.Location !== 0) {
      obj.Location = storageLocationsToJSON(message.Location);
    }
    if (message.LocalPath !== "") {
      obj.LocalPath = message.LocalPath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StorageSettings>, I>>(base?: I): StorageSettings {
    return StorageSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StorageSettings>, I>>(object: I): StorageSettings {
    const message = createBaseStorageSettings();
    message.Location = object.Location ?? 0;
    message.LocalPath = object.LocalPath ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
